import { useEffect } from "react";
import { CheckCircle2 } from "lucide-react";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

/** EF-3 — where the identity vendor sends the candidate when its flow ends.
 *
 *  A STATIC page on purpose. The check runs in a new tab while the test's own
 *  tab (the Gate) stays open and polls for the outcome, so this page has
 *  nothing to do except tell the person to go back. Because of that, the
 *  callback URL we give the vendor carries no candidate token and no id — the
 *  candidate's link never leaves the platform.
 *
 *  The vendor appends `?verificationSessionId=…&status=…`. Both are dropped
 *  from the address bar at once and never read: the status in a URL is an
 *  untrusted hint (anyone can type one), and the real outcome arrives
 *  server-side by signed webhook.
 *
 *  ⚠ Placeholder copy (wording is Emilia's). */
export default function IdentityDone() {
  useEffect(() => {
    if (window.location.search || window.location.hash) {
      window.history.replaceState(null, "", window.location.pathname);
    }
  }, []);

  return (
    <div className="flex min-h-full items-center justify-center bg-background p-6">
      <Card className="w-full max-w-lg">
        <CardHeader className="space-y-2">
          <CheckCircle2 className="h-8 w-8 text-success" aria-hidden="true" />
          <CardTitle as="h1" className="text-2xl">
            You&rsquo;re done here
          </CardTitle>
          <CardDescription>
            {/* OPS-15: legal supplies the final wording */}
            Close this tab and go back to the tab with your test. It updates on
            its own, and you can continue from there.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-xs text-muted-foreground">
            Nothing else is needed on this page.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
